<template>
    <el-dialog
        title="司机费用分账"
        width="500px"
        :visible="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'splitPaymentDialog'"
        >
        <el-form ref="formRef" :model="formData" :rules="rules" label-width="120px">
            <el-form-item label="已选：">{{ componentData.length }} 条发车单</el-form-item>
            <el-form-item label="支付对象：" prop="payObject">
                <otpSelect
                    :optionNum="'PAY_OBJECT'"
                    @getSelectValue="getSelectValue"
                    :mValue="formData.payObject"
                    placeholder="请选择支付对象"
                    :prop="'payObject'"
                >
                </otpSelect>
            </el-form-item>
            <el-form-item label="每笔分账金额：" prop="divideAmount">
                <el-input
                    v-model.trim="formData.divideAmount"
                    @input="validateInput"
                    placeholder="输入数字,最多2位小数"
                    maxlength="18"
                    show-word-limit
                    clearable>
                </el-input>
            </el-form-item>
        </el-form>
        <div>注：分账金额即每单需要支付给承运司机的费用，需大于发车单计费金额的 {{ divideRate.min }}% 且小于 {{ divideRate.max }}%。分帐后可通过"发起支付"完成支付</div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="beforeClose">取 消</el-button>
            <el-button type="primary" :loading="btnLoading" @click="handleSubmit">提 交</el-button>
        </div>
    </el-dialog>
</template>

<script>
import otpSelect from '@/components/lots/otpSelect';
import { dictWithUrl } from '@/components/lots/api.js';
import * as api from '@/modules/transport/otp/api/driverExpenseSplit.js';
export default {
    name: 'SplitPaymentDialog',
    components: { otpSelect },
    props: {
        componentData: {
            type: Array,
            default: () => []
        },
        divideType: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            btnLoading: false,
            formData: {
                payObject: '',
                divideAmount: ''
            },
            dictData: {},
            rules: {
                payObject: [
                    {
                        required: true,
                        message: '请选择支付对象',
                        trigger: ['blur', 'change']
                    }
                ],
                divideAmount: [
                    {
                        required: true,
                        message: '请输入分账金额',
                        trigger: ['blur', 'change']
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (value.endsWith('.')) {
                                callback(new Error('请输入正确格式的数字'));
                            }
                            callback();
                        },
                        trigger: ['blur']
                    }
                ]
            }
        };
    },
    computed: {
        divideRate () {
            if (this.dictData['CARRIER_DIVIDE_RANGE'] && Object.keys(this.dictData['CARRIER_DIVIDE_RANGE']).length) {
                return {
                    min: this.dictData['CARRIER_DIVIDE_RANGE']['min'] || '',
                    max: this.dictData['CARRIER_DIVIDE_RANGE']['max'] || ''
                };
            } else {
                return { min: '', max: '' };
            }
        }
    },
    async mounted () {
        await this.getDicData();
        if (this.divideType === 'adjust') {
            this.formData.payObject = this.componentData[0].payObject;
            this.formData.divideAmount = String(this.componentData[0].divideAmount);
        }
    },
    methods: {
        async getDicData () {
            const dict = await dictWithUrl(
                // eslint-disable-next-line max-len
                'CARRIER_DIVIDE_RANGE'
            );
            this.dictData = dict.data;
        },
        /**
         * @description: 高级下拉选中的回调
         * @param {*} data 选中的数据
         * @return {*}
         */
        getSelectValue (data) {
            Object.keys(data).forEach(key => {
                this.formData[key] = data[key];
            });
        },
        validateInput() {
            // 移除非数字和小数点
            this.formData.divideAmount = this.formData.divideAmount.replace(/[^0-9.]/g, '');

            // 防止输入以小数点开头，添加前导零
            if (this.formData.divideAmount.startsWith('.')) {
                this.formData.divideAmount = '0' + this.formData.divideAmount;
            }

            // 移除开头的多余零，但保留最后一个零
            this.formData.divideAmount = this.formData.divideAmount.replace(/^0+(?=\d)/, '');

            // 检查是否包含多个小数点
            const decimalCount = (this.formData.divideAmount.match(/\./g) || []).length;
            if (decimalCount > 1) {
                this.formData.divideAmount = this.formData.divideAmount.slice(0, this.formData.divideAmount.lastIndexOf('.'));
            }

            // 检查小数位数，限制为4位
            const decimalPart = this.formData.divideAmount.split('.')[1];
            if (decimalPart && decimalPart.length > 2) {
                this.formData.divideAmount = this.formData.divideAmount.slice(0, this.formData.divideAmount.lastIndexOf('.') + 3);
            }
        },
        /**
         * @description 关闭
         */
        beforeClose () {
            this.$emit('update:splitPaymentDialogShow', false);
        },
        /**
         * @description 提交
         */
        handleSubmit () {
            this.$refs.formRef.validate(valid => {
                if (valid) {
                    this.btnLoading = true;
                    const callApi = this.divideType === 'divide' ? api.divide : api.adjust;
                    const params = this.divideType === 'divide' ? this.getParams() : this.getParams()[0];
                    callApi(params).then(res => {
                        if (res && +res.code === 0) {
                            const { successList, failList, failReason } = res.data || {};
                            const h = this.$createElement;
                            this.$msgbox({
                                title: '司机费用分账',
                                message: h('div', null, [
                                    h('p', null, `分账成功：${Array.isArray(successList) ? successList.length : 0} 条发车单`),
                                    h('p', null, `分账失败：${Array.isArray(failList) ? failList.length : 0} 条发车单`),
                                    failReason ? h('p', null, `失败原因：${failReason || ''} `) : ''
                                ]),
                                showConfirmButton: true,
                                confirmButtonText: '确定',
                                customClass: 'driver-expense-split-message',
                                beforeClose: (action, instance, done) => {
                                    this.$emit('refresh', 'splitPaymentDialogShow');
                                    done();
                                }
                            }).catch(() => {});
                        }
                    })
                        .catch(() => { })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                };
            });
        },
        getParams () {
            return this.componentData.map(item => {
                return {
                    dispatchNo: item.dispatchNo,
                    payObject: this.formData.payObject,
                    divideAmount: Number(this.formData.divideAmount)
                };
            });
        }
    }
};
</script>

<style lang="less">
.splitPaymentDialog{
    .el-dialog__body {
        padding: 16px 36px 16px 16px;
    }
}
.driver-expense-split-message {
    .el-message-box__btns {
        text-align: center !important;
    }
}
</style>
